import React from 'react';
import { HeartHandshakeIcon } from 'lucide-react';
export function Mission() {
  return <section className="border-t border-ink-950/8 bg-canvas py-20 lg:py-28" data-id="element-112" data-mp="2k10og9w2i79e">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-113" data-mp="2k2ttjkr18jfa">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-20" data-id="element-114" data-mp="2y11s1x3pvssk">
          <figure className="overflow-hidden rounded-2xl" data-id="element-115" data-mp="2t0nsl3g6lr65">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/90541a67-11ae-450a-aded-33b3d5afdf9f.jpg" alt="A family swimming together in clear pool water" className="aspect-[3/2] w-full object-cover" loading="lazy" data-id="element-116" data-mp="2t39zr1z5u4nu" />
          </figure>

          <div className="flex flex-col justify-center" data-id="element-117" data-mp="3cp4u4ven2kc3">
            <p className="mb-4 inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-aqua-600" data-id="element-118" data-mp="3cpoeeirrhkta">
              <HeartHandshakeIcon className="h-4 w-4" aria-hidden="true" data-id="element-119" data-mp="3qmti4c4067ld" />
              Who we stand with
            </p>
            <h2 className="font-display text-3xl font-semibold leading-[1.1] tracking-tightest text-ink-950 lg:text-4xl" data-id="element-120" data-mp="3k0so45h9movz">
              Every Child A Swimmer
            </h2>
            <p className="mt-5 max-w-xl text-[16px] leading-relaxed text-ink-700" data-id="element-121" data-mp="3p1ztxyzule00">
              Every Child a Swimmer believes no child should ever lose their
              life to water. Their mission is to give every child &mdash; no
              matter their background &mdash; the chance to learn to swim, feel
              safe, and experience the joy of the water. Through education,
              compassion and community, they turn heartbreak into hope, one swim
              lesson at a time.
            </p>
            <p className="mt-8 max-w-xl border-t border-ink-950/10 pt-8 text-[15px] leading-relaxed text-ink-600" data-id="element-122" data-mp="lj6usr7tgrpd">
              <span className="font-medium text-ink-950" data-id="element-123" data-mp="plaa5qxlwgfx">
                Authorized dealers.
              </span>{' '}
              Hydrosprings is an authorized dealer and installer of the Fusion
              44X system. The name behind our distribution is carefully chosen
              to reflect our brand&rsquo;s values and standards &mdash; text us
              to reach your nearest certified installer.
            </p>
          </div>
        </div>
      </div>
    </section>;
}